export default "__VITE_ASSET__16842258__"